import {Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {CheckConfig, ChecksSettings} from "../../../../model/channels.model";

@Component({
  selector: "admin-channels-view-checks",
  templateUrl: "./checks.component.html",
  styleUrls: ["./checks.component.css"]
})
export class AdminChannelsViewChecksComponent implements OnChanges {

  @Input() settings?: ChecksSettings;

  checks: CheckConfig[]

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["settings"]) {
      this.checks = this.settings?.checks!
    }
  }

  getNumberValue(value: number | undefined) {
    return value ?? 0.0;
  }

  renderBorder(check: CheckConfig) {
    if (check.hint == "excluded") {
      return "config-item-border-exclude";
    } else if (check.hint == "required") {
      return "config-item-border-required";
    } else {
      return "";
    }
  }

}
